export const getQueryStringByKey = (key: string, search?: string) =>
  new URLSearchParams(search)?.get(key);
